import { FC } from 'react';
import { TUserState } from '../../store/authSlice';
import getInitialsName from '../../utils/getInitialsName';

const UserAvatar: FC<{ user: TUserState , size?: 'small' | 'medium' | 'large' }> = ({ user, size = 'small' }) => user
  ? (
    <div 
      className="flex w-[30px] h-[30px] rounded-full bg-gray-400 text-white items-center justify-center text-xs font-medium"
      style={{
        backgroundImage: user?.avatarURL ? `url(${user.avatarURL})` : '',
        backgroundPosition: 'center',
        backgroundSize: 'contain',         
      }}
    >
      {!user?.avatarURL && getInitialsName(user?.firstName || '')}
    </div>
  ) : null;

export default UserAvatar;
